import { render, staticRenderFns } from "./AvatarUpload.vue?vue&type=template&id=f8fb27c8&scoped=true&"
import script from "./AvatarUpload.vue?vue&type=script&lang=ts&"
export * from "./AvatarUpload.vue?vue&type=script&lang=ts&"
import style0 from "./AvatarUpload.vue?vue&type=style&index=0&id=f8fb27c8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8fb27c8",
  null
  
)

export default component.exports